// src/services/productService.js

import apiService from "./apiService";

// === PRODUCTS ===
const getAllProducts = () => apiService.getAll("backend/products");
const getProductById = (id) => apiService.getById("backend/products", id);
const createProduct = (data) => apiService.create("backend/products", data);
const createProductWithFile = (data) => apiService.createWithFile("backend/products", data);
const updateProduct = (id, data) => apiService.update("backend/products", id, data);
const updateProductWithFile = (id, data) =>
  apiService.post(`backend/products/${id}`, data);
// const updateProductWithFile = (id, data) => apiService.updateWithFile("backend/products", id, data);
const deleteProduct = (id) => apiService.remove("backend/products", id);
// Advertisement Status Update
const updateAdvertisementStatus = (id, is_advertised) =>
  apiService.post(`backend/products/${id}/update-status-advertisement`, {
    is_advertised,
  });
// Create Advertisement
const createAdvertisement = (id, data) =>
  apiService.post(`backend/products/${id}/create-advertisement`, data);
// Update Advertisement Details
const updateAdvertised = (id, data) =>
  apiService.post(`backend/products/${id}/create-advertisement`, data);

// Get Advertisement Products
const getAdvertisedProducts = () =>
  apiService.getAll("backend/products/advertisement");

const getApprovedProducts = () => apiService.getAll("backend/products/approved");
const getUnapprovedProducts = () => apiService.getAll("backend/products/unapproved");

const getSoldProducts = () => apiService.getAll("backend/products/sold");
const getOfferesProducts = () => apiService.getAll("backend/products/offers");

const changeProductStatus = (id, status) =>
  apiService.post(`backend/products/${id}/status`, { status });
const changePrescriptionStatusOfProduct = (id, is_prescription) =>
  apiService.post(`backend/products/${id}/change-prescription-status`, { is_prescription });

const changeProductApprovalStatus = (id, is_approved) =>
  apiService.post(`backend/products/${id}/approval`, { is_approved });

const getAllBrands = () => apiService.getAll("backend/brands");

// === CATEGORIES ===
const getAllCategories = () => apiService.getAll("backend/categories"); 

// === SUB-CATEGORIES ===
const getAllSubCategories = () => apiService.getAll("backend/sub-categories");

// // === CHILD CATEGORIES ===
const getAllChildCategories = () => apiService.getAll("backend/child-categories");

// // === BRANDS ===
// const getAllBrands = () => apiService.getAll("backend/brands");

// === PRODUCT VARIANTS ===
const getAllProductVariants = (productId) => apiService.getAll(`products/${productId}/variants`);
const getProductVariantById = (productId, variantId) =>
  apiService.getById(`products/${productId}/variants`, variantId);
const createProductVariant = (productId, data) =>
  apiService.create(`products/${productId}/variants`, data);
const updateProductVariant = (productId, variantId, data) =>
  apiService.update(`products/${productId}/variants`, variantId, data);
const deleteProductVariant = (productId, variantId) =>
  apiService.remove(`products/${productId}/variants`, variantId);

// === VARIANT ITEMS ===
const getAllVariantItems = (variantId) => apiService.getAll(`variants/${variantId}/items`);
const getVariantItemById = (variantId, itemId) =>
  apiService.getById(`variants/${variantId}/items`, itemId);
const createVariantItem = (variantId, data) =>
  apiService.create(`variants/${variantId}/items`, data);
const updateVariantItem = (variantId, itemId, data) =>
  apiService.update(`variants/${variantId}/items`, itemId, data);
const deleteVariantItem = (variantId, itemId) =>
  apiService.remove(`variants/${variantId}/items`, itemId);

// === PRODUCT IMAGES ===

// Upload image
const uploadProductImages = (formData) => {
  return apiService.post(
    "backend/product-image-gallery",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};


// Get images
const getProductImages = (productId) =>
  apiService.getAll(`backend/product-image-gallery?product_id=${productId}`);

// Delete image
const deleteProductImage = (imageId) =>
  apiService.delete(`backend/product-image-gallery/${imageId}`);



// Product Reviews
const getProductReviews = (productId) =>
  apiService.getAll(`backend/admin-reviews?product_id=${productId}`);

const changeProductReviewStatus = (id, status) =>
  apiService.post(`backend/reviews/${id}/status`, { status });

//CREATING  BULK PRODUCT API 
const bulkImportProducts = (formData, onUploadProgress) => {
  return apiService.post(
    "backend/products/bulk-import",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        if (progressEvent?.total && onUploadProgress) {
          onUploadProgress(progressEvent);
        }
      },
    }
  );
};

// === HOME SECTIONS ===
const getAllHomeSections = () => apiService.getAll("backend/home-sections");

const createHomeSection = (data) =>
  apiService.post("backend/home-sections", data);

const updateHomeSection = (id, data) => 
  apiService.update("backend/home-sections", id, data);

const deleteHomeSection = (id) =>
  apiService.remove("backend/home-sections", id);


// BULK DELETE
const bulkDeleteProducts = (ids) =>
  apiService.delete("backend/products/bulk-delete", {
    data: { ids },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
// BULK APPROVED

  const bulkApproveProducts = (ids, is_approved) =>
  apiService.post(
    "backend/products/bulk-approved",
    {
      ids,
      is_approved,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  ); 

// =========================================================
// ROLES
// =========================================================

const getAllRoles = () => {
  return apiService.getAll("backend/roles");
};

const getRolePermissions = (roleId) => {
  return apiService.getAll(`backend/roles/${roleId}/permissions`);
};


// === EXPORT ===
const productService = {
  // Products
  getAllProducts,
  getProductById,
  createProduct,
  createProductWithFile,
  updateProduct,
  updateProductWithFile,
  deleteProduct,
  changeProductStatus,
  changeProductApprovalStatus,
  getApprovedProducts,
  getUnapprovedProducts,
  getSoldProducts,
  getOfferesProducts,
  bulkImportProducts,
  bulkDeleteProducts, 
  bulkApproveProducts,
updateAdvertisementStatus,
createAdvertisement,
updateAdvertised,
getAdvertisedProducts,
  getAllRoles,
  getRolePermissions,
  // Categories
  getAllCategories,
  getAllSubCategories,
  getAllChildCategories,
  getAllBrands,

  // Variants
  getAllProductVariants,
  getProductVariantById,
  createProductVariant,
  updateProductVariant,
  deleteProductVariant,

  // Variant Items
  getAllVariantItems,
  getVariantItemById,
  createVariantItem,
  updateVariantItem,
  deleteVariantItem,

  // Images
  uploadProductImages,
  getProductImages,
  deleteProductImage,

  // Reviews
  getProductReviews,
  changeProductReviewStatus,
  getAllHomeSections,
  createHomeSection,
  updateHomeSection,
  deleteHomeSection, 

changePrescriptionStatusOfProduct 
};

export default productService;
